var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarutiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.251,
    height: 31.674,
    viewBox: "0 0 288.251 31.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12757",
    "data-name": "Group 12757",
    transform: "translate(-1799.955 -230.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M15.7,0A57.245,57.245,0,0,1,.135,9.637l20.15,14.422-1.146.539-8.357-5.526c-2.7-1.82-9.435-.539-10.783,1.752l15.5,10.85a49.2,49.2,0,0,1,15.635-9.907L10.783,7.615l1.078-.876,6.6,4.717c3.3,2.359,5.931,2.965,13.007-.539Z",
    transform: "translate(1799.956 230.807)",
    fill: "#c5c6c6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M70.1,11.7h8.828l2.628,9.233L84.185,11.7h8.761V27.537H87.285V16.215h-.067l-3.3,11.322H79.2L75.83,16.215V27.537H70.1Z",
    transform: "translate(1777.099 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M115.815,16.485h0l-1.887,5.391H117.7ZM111.907,11.7h7.683l6.739,15.837h-6.672l-.674-1.82h-6.537l-.674,1.82H105.1Z",
    transform: "translate(1765.686 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M168.6,11.7h6.268v9.57c0,2.022,1.146,2.7,3.235,2.7,2.022,0,3.235-.674,3.235-2.7V11.7H187.6v9.839c0,5.054-3.033,6.537-9.5,6.537-6.4,0-9.5-1.55-9.5-6.537Z",
    transform: "translate(1744.98 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M204.4,15.676h-5.8V11.7h17.859v3.976h-5.8V27.537H204.4Z",
    transform: "translate(1735.198 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 6.268,
    height: 15.837,
    transform: "translate(1952.938 238.692)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M143.868,15.676h4.381c1.011,0,1.82.27,1.82,1.483,0,1.011-.539,1.483-1.752,1.483h-4.448Zm14.287,11.861-5.324-4.92c4.381-.674,3.841-4.987,3.841-6.47a4.284,4.284,0,0,0-2.157-3.841,8.724,8.724,0,0,0-3.774-.607H137.6V27.537h6.268V22.685h1.078l5.257,4.852Z",
    transform: "translate(1755.089 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M264.315,20.537c-3.033-.472-4.313-2.224-4.313-4.448,0-4.111,4.044-5.189,9.165-5.189,7.076,0,9.974,1.82,10.176,5.189h-7.278a1.378,1.378,0,0,0-.943-1.28,4.593,4.593,0,0,0-1.954-.337c-1.887,0-2.493.472-2.493,1.146,0,.472.2.741.809.809l7.481,1.078c3.167.472,5.122,1.954,5.122,4.583,0,3.841-3.167,5.661-10.176,5.661-4.785,0-10.041-.674-10.109-5.324h7.548a1.186,1.186,0,0,0,.674,1.146,5.5,5.5,0,0,0,2.157.337c1.954,0,2.494-.539,2.494-1.28,0-.472-.27-.943-1.146-1.078Z",
    transform: "translate(1715.242 227.253)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M292.4,11.7h6.268v9.57c0,2.022,1.146,2.7,3.235,2.7,2.022,0,3.235-.674,3.235-2.7V11.7H311.4v9.839c0,5.054-3.033,6.537-9.5,6.537-6.4,0-9.5-1.55-9.5-6.537V11.7",
    transform: "translate(1704.612 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M323,24.168l9.5-8.491h-8.828V11.7h17.253v3.437l-9.233,8.424h9.031v3.976H323Z",
    transform: "translate(1694.634 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M352.1,11.7h6.268v9.57c0,2.022,1.146,2.7,3.235,2.7,2.022,0,3.235-.674,3.235-2.7V11.7H371.1v9.839c0,5.054-3.033,6.537-9.5,6.537-6.4,0-9.5-1.55-9.5-6.537V11.7",
    transform: "translate(1685.146 226.992)",
    fill: "#2d3394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M384.3,27.537h6.065l-.135-5.661,6.133,5.661h7.952l-8.694-8.087,9.165-7.75h-7.615l-6.807,5.459V11.7H384.3Z",
    transform: "translate(1674.646 226.992)",
    fill: "#2d3394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1662",
    "data-name": "Rectangle 1662",
    width: 6.268,
    height: 15.837,
    transform: "translate(2081.938 238.692)",
    fill: "#2d3394"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarutiLogo);
export default __webpack_public_path__ + "static/media/maruti-logo.6f853f0d052a984823dcc94ce3224fd1.svg";
export { ForwardRef as ReactComponent };